
import React from 'react';
import { ModalCampaignQuestion } from '@/types/modalCampaigns';
import ModalContent from './ModalContent';

interface ModalContentRendererProps {
  content: string;
  hasQuiz: boolean;
  questions: ModalCampaignQuestion[];
  userAnswers: Record<string, string[]>;
  quizSubmitted: boolean;
  quizPassed: boolean;
  score: number;
  minScore: number;
  attemptNumber: number;
  maxAttempts: number | null;
  attemptsExhausted: boolean;
  currentQuestionIndex: number;
  onAnswer: (questionId: string, selectedOptions: string[]) => void;
  onSubmit: () => void;
  onReset: () => void;
  onPrevQuestion: () => void;
  onNextQuestion: () => void;
}

const ModalContentRenderer: React.FC<ModalContentRendererProps> = (props) => {
  // Check if the current question has answers selected
  const currentQuestion = props.questions[props.currentQuestionIndex];
  const currentQuestionAnswers = currentQuestion ? props.userAnswers[currentQuestion.id] || [] : [];
  const hasSelectedOptions = currentQuestionAnswers.length > 0;
  
  return (
    <ModalContent
      content={props.content}
      hasQuiz={props.hasQuiz}
      questions={props.questions}
      userAnswers={props.userAnswers}
      quizSubmitted={props.quizSubmitted}
      quizPassed={props.quizPassed}
      score={props.score}
      minScore={props.minScore}
      attemptNumber={props.attemptNumber}
      maxAttempts={props.maxAttempts}
      attemptsExhausted={props.attemptsExhausted}
      currentQuestionIndex={props.currentQuestionIndex}
      onAnswer={props.onAnswer}
      onSubmit={props.onSubmit}
      onReset={props.onReset}
      onPrevQuestion={props.onPrevQuestion}
      onNextQuestion={props.onNextQuestion}
      hasSelectedOptions={hasSelectedOptions}
    />
  );
};

export default ModalContentRenderer;
